import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Slide } from "react-awesome-reveal";

function TimelineEventRight({ imgSrc, date, name, description }) {
    let duration = 200;
    let delay = 100;
    let fraction = 0.05;
    return <div className="timeline-container">
        <div className="timeline-content-left">
            <Slide direction="left" cascade triggerOnce delay={delay} duration={duration} fraction={fraction}>
                <img className="timeline-img" src={imgSrc} alt="" />
            </Slide>
        </div>
        <div className="timeline-content-right">
            <div className="timeline-text">
                <h2>{date}</h2>
                <h3>{name}</h3>
                <p>{description}</p>
            </div>
        </div>
    </div>;
}

function TimelineEventLeft({ imgSrc, date, name, description }) {
    let duration = 200;
    let delay = 100;
    let fraction = 0.05;
    return <div className="timeline-container">
        <div className="timeline-content-left">
            <div className="timeline-text">
                <h2>{date}</h2>
                <h3>{name}</h3>
                <p>{description}</p>
            </div>
        </div>
        <div className="timeline-content-right">
        <Slide direction="right" cascade triggerOnce delay={delay} duration={duration} fraction={fraction}>
                <img className="timeline-img" src={imgSrc} alt="" />
            </Slide>
        </div>
    </div>;
}

export function Events() {
    const [events, setEvents] = useState([]);

    useEffect(() => {
        const fetchEvents = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/NotableEvents`);
                setEvents(response.data);
            } catch (error) {
                console.error('Error fetching events:', error);
            }
        };

        fetchEvents();
    }, []);

    return (
        <div id="events" className="container-fluid my-5 py-5 section">
            <div className="container">
                <div className="row g-4">
                    <h2 className="text-secondary text-uppercase">Szczególne wydarzenia</h2>
                    <div className="timeline">
                        {events.map((event, index) => (
                            index % 2 === 0 ? (
                                <TimelineEventRight
                                    key={event.id}
                                    imgSrc={process.env.REACT_APP_API_BASE_URL + "/" + event.pictureUrl}
                                    date={event.date}
                                    name={event.name}
                                    description={event.description}
                                />
                            ) : (
                                <TimelineEventLeft
                                    key={event.id}
                                    imgSrc={process.env.REACT_APP_API_BASE_URL + "/" + event.pictureUrl}
                                    date={event.date}
                                    name={event.name}
                                    description={event.description}
                                />
                            )
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}